import { useEffect, useState } from 'react'
import { Product } from '../../../components/productCard/data';
import { decode } from 'html-entities';
import { sortProductsByStock } from '../Equipment';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { ButtonComponent, ContainerComponent, ParagraphComponent, ProductCardComponent, ProductCardSkeletonComponent, SubtitleComponent, TitleComponent } from '../../../components';
import useProductStore from '../../../store/productStore';

function Cables() {
    const { cables, fetchCables, loading, error } = useProductStore();
    const [tempSolarProducts, setTempSolarProducts] = useState<Product[]>(cables.products);
    const [currentPage, setCurrentPage] = useState(1)

    const { t, i18n } = useTranslation();

    useEffect(() => {
        if (cables.products.length === 0) fetchCables(0)
    }, [])

    useEffect(() => {
        const sortedProducts = sortProductsByStock(cables.products);
        setTempSolarProducts(sortedProducts);
    }, [cables]);


    return (
        <div className="equipment" id="equipmentContainer">
            <Helmet>
                <title>{t('solarEquipment.meta5')}</title>
                <meta name="description" content={t('solarEquipment.meta.description')} />
            </Helmet>
            <ContainerComponent>
                <h1><TitleComponent centered smaller style={{ marginTop: '3rem' }}>{t('solarEquipment.title5')}</TitleComponent></h1>
                <SubtitleComponent centered>{t('solarEquipment.subtitle')}</SubtitleComponent>
                {loading ? <div className="productCardContainer">
                    <ProductCardSkeletonComponent />
                    <ProductCardSkeletonComponent />
                    <ProductCardSkeletonComponent />
                    <ProductCardSkeletonComponent />
                    <ProductCardSkeletonComponent />
                    <ProductCardSkeletonComponent />
                    <ProductCardSkeletonComponent />
                </div> : <>
                    <div className="productCardContainer">
                        {tempSolarProducts.length > 0 ? <ProductCardComponent data={tempSolarProducts} /> : <ParagraphComponent>{error?.message}</ParagraphComponent>}


                    </div>
                </>}
                {cables.pagination.page_count && currentPage <= cables.pagination.page_count - 1 ?
                    <ButtonComponent style={{ margin: '0 auto', display: 'block' }} onClick={() => { setCurrentPage(currentPage + 1); fetchCables(currentPage) }}>Load more</ButtonComponent>
                    : ''}
                {/* {cables.pagination.total ? <p style={{ color: 'white' }}>{tempSolarProducts.length} of {cables.pagination.total} Products</p> : ''} */}
            </ContainerComponent>
        </div>
    )
}

export default Cables